import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useParams } from 'react-router-dom';
import CreateEditWorkflow from './create-edit-workflow';
import CreateEditWorkflowLegacy from './create-edit-workflow-legacy';
const LEGACY_WORKFLOW_STORAGE_KEY = 'triyo_legacy_workflow_enabled';

const CreateEditWorkflowRouter = ({ isLegacy: legacyProp, id: idProp }) => {
  const location = useLocation();
  const params = useParams();

  const isEditMode = location.pathname.includes('/edit/');

  const [useLegacyMode, setUseLegacyMode] = useState(() => {
    const stored = localStorage.getItem(LEGACY_WORKFLOW_STORAGE_KEY);
    return stored === 'true';
  });

  useEffect(() => {
    if (!isEditMode) {
      localStorage.setItem(LEGACY_WORKFLOW_STORAGE_KEY, useLegacyMode.toString());
    }
  }, [useLegacyMode, isEditMode]);

  const queryLegacy = useMemo(() => {
    const sp = new URLSearchParams(location.search);
    if (!sp.has("legacy")) return undefined; // absence => undefined
    return sp.get("legacy") === "true"; // present => boolean
  }, [location.search]);

  // For EDIT mode: use the Legacy flag from navigation state (passed from workflow table via API)
  // For CREATE mode: use the toggle state (useLegacyMode)
  const isLegacy = isEditMode
    ? (location.state?.isLegacy ?? queryLegacy ?? legacyProp ?? false)
    : (useLegacyMode ?? location.state?.isLegacy ?? queryLegacy ?? legacyProp ?? false);

  const id = idProp ?? params?.id ?? undefined;

  const handleToggleChange = (e) => {
    setUseLegacyMode(e.target.checked);
  };

  // Only show toggle in create mode
  const toggleProps = {
    useLegacyMode: isEditMode ? isLegacy : useLegacyMode, // In edit mode, reflect the actual legacy state
    onToggleChange: handleToggleChange,
    showLegacyToggle: !isEditMode, // Hide toggle completely in edit mode
  };

  return (
    <>
      {!isLegacy && <CreateEditWorkflow id={id} {...toggleProps} />}
      {isLegacy && <CreateEditWorkflowLegacy id={id} {...toggleProps} />}
    </>
  );
};

CreateEditWorkflowRouter.propTypes = {
  isLegacy: PropTypes.bool,
  id: PropTypes.string
};

export default CreateEditWorkflowRouter;
